"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Receiver = void 0;
var receiver_client_1 = require("./receiver-client");
var util_1 = require("../../../util");
var receiver_interface_1 = require("./receiver.interface");
var websocket_channel_1 = require("../../../websocket-channel");
var page_visibility_checker_1 = require("./page-visibility-checker");
var Receiver = /** @class */ (function () {
    function Receiver(dependency) {
        var _this = this;
        this.dependency = dependency;
        this.tag = 'Receiver';
        this.isConnectSuccess = false;
        this.delayConnectTimer = 0;
        /**
         * 心跳计时器，超过45s没有收到后台的信息就认为连接挂掉了
         */
        this.connectionCheckTimer = 0;
        /**
         * 重试次数
         */
        this.retryTimes = 0;
        this.pageVisibilityChecker = new page_visibility_checker_1.PageVisibilityChecker({
            resumeCallback: function () { return _this.receive(); },
        });
    }
    Receiver.prototype.dispose = function () {
        this.stopToReceive();
        this.receiverClientInstance = undefined;
    };
    /**
     * 中止请求
     */
    Receiver.prototype.stopToReceive = function () {
        this.receiverClient.abortConnection();
        this.clearTimer();
    };
    /**
     * 建立下行通道
     */
    Receiver.prototype.receive = function () {
        util_1.ConnectionLog.info("\u5927\u534F\u540Cbind get receive isHidden:" + this.pageVisibilityChecker.isHidden + ", retryTimes:" + this.retryTimes);
        // 1、页面可见检测，减少不可见时，receive 请求
        if (this.pageVisibilityChecker.isHidden) {
            this.pageVisibilityChecker.resumeAfterVisibility();
            return;
        }
        // 判断是否需要延迟重连
        if (this.retryTimes) {
            this.delayConnect();
            return;
        }
        this.retryTimes = this.retryTimes + 1;
        this.isConnectSuccess = false;
        // 2、发起下行请求，接收信息
        this.receiverClient.establishConnection(this.getUrl());
    };
    Receiver.prototype.delayConnect = function () {
        var _this = this;
        // 1、重试三次后，直接重连
        if (this.retryTimes >= 3) {
            util_1.ConnectionLog.info('大协同bind get请求，重试三次失败，重新发起post鉴权');
            this.retryTimes = 0;
            this.dependency.reconnect({
                attrName: 'bind get 连续重试三次连接失败',
                reason: '超时、请求状态异常等错误',
            });
            return;
        }
        this.isConnectSuccess = false;
        if (this.delayConnectTimer) {
            clearTimeout(this.delayConnectTimer);
            this.delayConnectTimer = 0;
        }
        this.delayConnectTimer = setTimeout(function () {
            _this.retryTimes = _this.retryTimes + 1;
            _this.receiverClient.establishConnection(_this.getUrl());
        }, receiver_interface_1.CONNECT_DELAY_TIME);
    };
    Receiver.prototype.getUrl = function () {
        var _a = this.dependency.getServerParams(), token = _a.token, sid = _a.sid, routeKey = _a.routeKey;
        return receiver_interface_1.PATH + "?sid=" + sid + "&token=" + token + "&routeKey=" + routeKey + "&taskId=" + util_1.generateMessageTaskId();
    };
    /**
     * 处理服务端推送数据入口
     * @param result
     */
    Receiver.prototype.handleResponse = function (result) {
        var _this = this;
        if (Number.parseInt(result, 16) || Number.parseInt(result, 16) === 0) {
            return;
        }
        var dataArrs = util_1.JsonUtil.parseJson(result);
        if (!Array.isArray(dataArrs)) {
            return;
        }
        dataArrs.forEach(function (data) {
            var _a = __read(data, 2), messageIndex = _a[0], message = _a[1];
            if (receiver_interface_1.ERROR_MESSAGE_INDEX.includes(messageIndex)) {
                _this.handleResponseEnd(message);
                return;
            }
            // 心跳处理 直接retrun就好了，收到消息就会处理ServerReachable
            if (message.includes(receiver_interface_1.NOOP)) {
                return;
            }
            // 正常head body处理
            _this.dependency.handleServerMessage(message);
        });
        // 服务可达，证明连接正常
        this.connectionIsStable();
    };
    /**
     * 连接稳定，更新连接状态，清除定时器
     */
    Receiver.prototype.connectionIsStable = function () {
        var _this = this;
        clearTimeout(this.connectionCheckTimer);
        this.connectionCheckTimer = 0;
        this.retryTimes = 0;
        if (this.dependency.isDisconnected()) {
            util_1.ConnectionLog.info(this.tag + " connectStatus is disconnected.");
            return;
        }
        if (!this.isConnectSuccess) {
            this.isConnectSuccess = true;
            this.dependency.onConnectSuccess();
        }
        this.connectionCheckTimer = setTimeout(function () {
            _this.isConnectSuccess = false;
            _this.receive();
        }, receiver_interface_1.MAX_SERVER_REACHABLE_TIME);
    };
    Receiver.prototype.handleResponseEnd = function (serverMessage) {
        var _a = __read(serverMessage, 2), retcode = _a[0], errorMessage = _a[1];
        if (this.notNeedToHandle(retcode)) {
            return;
        }
        if (retcode === websocket_channel_1.RoomWebsocketErrorCode.SOCKET_SERVER_SUCCESS) {
            this.receive();
        }
        else {
            util_1.ConnectionLog.info("Bind Get Error, retcode: " + retcode + ", msg: " + errorMessage);
            this.dependency.reconnect({
                attrName: String(retcode !== null && retcode !== void 0 ? retcode : 0),
                reason: "Bind Get Error, retcode: " + retcode + ", msg: " + errorMessage,
            });
            return;
        }
    };
    Receiver.prototype.notNeedToHandle = function (retcode) {
        return websocket_channel_1.NOT_NEED_TO_HANDLE_ERRCODES.includes(retcode);
    };
    Object.defineProperty(Receiver.prototype, "receiverClient", {
        get: function () {
            var _this = this;
            if (!this.receiverClientInstance) {
                this.receiverClientInstance = new receiver_client_1.ReceiverClient({
                    handleResponse: function (res) { return _this.handleResponse(res); },
                    receive: function () { return _this.receive(); },
                    disconnect: function (reason) { return _this.dependency.disconnect(reason); },
                });
            }
            return this.receiverClientInstance;
        },
        enumerable: false,
        configurable: true
    });
    Receiver.prototype.clearTimer = function () {
        if (this.delayConnectTimer) {
            clearTimeout(this.delayConnectTimer);
            this.delayConnectTimer = 0;
        }
        if (this.connectionCheckTimer) {
            clearTimeout(this.connectionCheckTimer);
            this.connectionCheckTimer = 0;
        }
    };
    return Receiver;
}());
exports.Receiver = Receiver;
